var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-group',[_c('v-rect',{ref:"multiAnnBoxSelection",attrs:{"config":_vm.tableConfig,"stroke-scale-enabled":false},on:{"dragstart":_vm.changeStart,"dragend":_vm.onChange,"transformstart":_vm.changeStart,"transformend":_vm.onChange}}),_c('v-transformer',{ref:"multiAnnBoxTransformer",attrs:{"config":_vm.transformerConfig}}),(_vm.showButton)?_c('v-label',{attrs:{"config":_vm.buttonConfig},on:{"mouseenter":_vm.onButtonEnter,"mouseleave":_vm.onButtonLeave}},[_c('v-tag',{attrs:{"config":{
        fill: '#7B61FF',
        cornerRadius: 4,
        name: 'tag',
      }}}),_c('v-text',{attrs:{"config":{
        align: 'right',
        width: _vm.buttonWidth,
        ellipsis: true,
        wrap: 'none',
        padding: 8,
        text: _vm.$t('new_multi_ann_title'),
        fill: 'white',
        fontSize: 14,
        cursor: 'pointer',
        name: 'multiAnnButton',
      }},on:{"click":_vm.openMultiAnnotationModal}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }